// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width: 767px) {\n  .center-style {\n    align-items: center !important;\n  }\n}", "",{"version":3,"sources":["webpack://./src/pages/users/index.scss"],"names":[],"mappings":"AACA;EACE;IACE,8BAAA;EAAF;AACF","sourcesContent":["\n@media only screen and (max-width: 767px) {\n  .center-style {\n    align-items: center !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
